import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { FaSave, FaTimes, FaSpinner, FaTrash } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";

const CustomersForm = () => {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;
  const {logout} = useAuth();

  const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        "Content-Type": "application/json",
      },
    };
  };

  useEffect(() => {
	  if (isEdit) {
		axios
		  .get(`${API}/customers/${id}`, getAuthHeader())
		  .then((res) => {
			//console.log("Customer response:", res.data); // <-- tambahkan log
			const customer = res.data;
			if (!customer || Object.keys(customer).length === 0) {
			  alert("Customer not found or not accessible.");
			  navigate("/customers");
			  return;
			}

			setFormData({
			  name: customer.name || "",
			  phone: customer.phone || "",
			  address: customer.address || "",
			});
		  })
		  .catch((err:any) => {
          //console.error("Failed to fetch vendor", err);
		  if (err.response?.status === 401) {
		  logout();
		  navigate("/login"); // redirect ke login
		}
        });
	  }
	}, [id]);


  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name) {
      alert("Fill all mandatory fields!");
      return;
    }

    const confirmSave = window.confirm("Do you want to save this data?");
    if (!confirmSave) return;

    setLoading(true);

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const customerCode = "1";
      const payload = isEdit
        ? { ...formData, customerCode }
        : {
            ...formData,
            tenantId: user.tenantId,
            createdByUserId: user.id,
            customerCode,
          };

      if (isEdit) {
        await axios.put(`${API}/customers/${id}`, payload, getAuthHeader());
        alert("Customer updated!");
      } else {
        await axios.post(`${API}/customers`, payload, getAuthHeader());
        alert("Customer saved!");
      }

      navigate("/customers");
    } catch (error) {
      //console.error("Failed to save customer:", error);
      alert("Failed to save customer");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this data?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API}/customers/${id}`, getAuthHeader());
      alert("Customer deleted");
      navigate("/customers");
    } catch (err) {
      console.error("Delete error:", err);
      alert("Failed to delete customer");
    }
  };

  return (
    <div className="p-1 max-w-6xl mx-auto">
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">		  
		  <h2 className="text-lg font-semibold text-gray-700">
			{isEdit ? "Edit Customer" : "Add Customer"}
          </h2>
          <div className="flex gap-2">
            <button
              type="submit"
              form="customer-form"
              disabled={loading}
              className="bg-blue-600 text-white px-2 py-1 rounded flex items-center gap-2 text-[13px] hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? <FaSpinner className="animate-spin" /> : <FaSave />}
              Save
            </button>
            <button
              onClick={() => navigate("/customers")}
              disabled={loading}
              className="bg-gray-300 text-gray-800 px-2 py-1 rounded flex items-center gap-2 text-[13px] hover:bg-gray-400 disabled:opacity-50"
            >
              <FaTimes />
              Cancel
            </button>
			
            {isEdit && (
              <button
                onClick={handleDelete}
                disabled={loading}
                className="bg-red-600 text-white px-2 py-1 rounded flex items-center gap-2 text-[13px] hover:bg-red-700 disabled:opacity-50"
              >
                <FaTrash />
                Delete
              </button>
            )}
          </div>
        </div>

        <form id="customer-form" onSubmit={handleSubmit} className="space-y-4">
          {/* Horizontal Form Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
            {/* Name */}
            <div className="flex items-center">
              <label className="w-32 text-[13px] font-medium">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="flex-1 border rounded px-2 py-1 text-[13px]"
              />
            </div>

            {/* Phone */}
            <div className="flex items-center">
              <label className="w-32 text-[13px] font-medium">
                Phone
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="flex-1 border rounded px-2 py-1 text-[13px]"
              />
            </div>


            {/* Address */}
            <div className="flex items-start">
              <label className="w-32 text-[13px] font-medium mt-2">
                Address
              </label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows={3}
                className="flex-1 border rounded px-2 py-1 text-[13px]"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomersForm;
